export function demoErrorToolsEnabled (env) {
  env = env || process.env

  const deploymentEnvironment = String(env.VUE_APP_DEPLOYMENT_ENV || env.NODE_ENV || '').toLowerCase()
  const explicitlyEnabled = String(env.VUE_APP_DEMO_ERROR_TOOLS_ENABLED || '').toLowerCase() === 'true'

  return explicitlyEnabled && ['development', 'staging'].includes(deploymentEnvironment)
}
